export default {
  allAssets: 'Alle Anlagen',
  zeroAssets: '0 Anlagen sind ausgewählt',
  assets: 'Anlagen',
};
